import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { appNamedRoutes, linkWithParams } from '../../routes';
import { join } from 'lodash';
import { isTeacher, isChatEnabled } from '../../utils/authScopes';
import { avatarUrl } from '../../utils/Formatters';

const PlayerHeader = ({ auth, locationFrom, player, playerQuestionnaireId, search, webNotesCount, showSurveyNotesModal }) => {
  if (!player) return null;
  const backLink = locationFrom ? locationFrom : { pathname: appNamedRoutes.root, search: search };
  const isFromRoot = !locationFrom || /dashboard\/?$/.test(locationFrom.pathname);
  const isFromASQ = !locationFrom || /dashboard\/asqs?$/.test(locationFrom.pathname);
  const isThatTeacher = isTeacher(auth);
  const backLinkText = isFromRoot ? 'Back to all Children' : '  Back';
  const bg = { backgroundImage: avatarUrl(player) };
  return (
    <div className='o-player-header u-margin-top--base u-margin-bottom--large'>
      <div className='row'>
        <div className='column'>
          <Link className='o-sp-button o-sp-button--back' to={backLink}>
            <i className='sp-icon-arrow-left'></i>&nbsp;{backLinkText}
          </Link>
        </div>
      </div>
      <div className='row u-margin-top--base'>
        <div className='column u-flex align-middle'>
          <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
          <div className='u-flex u-flex-column'>
            <div className='u-flex u-flex-gap' style={{ alignItems: 'center' }}>
              {isFromASQ && !isThatTeacher ?
                <Link className='cs-txt-link--sp-blue' to={{pathname: linkWithParams('accountPlayer', {id: player.id})}}>
                  <strong>{player.name}</strong>
                  <br/>
                </Link>
                : <strong>{player.name}</strong>
              }
              {isChatEnabled(auth) &&
                <Link className='cs-txt-link--sp-blue'
                  to={{
                    pathname: appNamedRoutes.communicationDashboard,
                    search: `?id=${player.id}`
                  }}
                  title="Coaching">
                  <i className='fa fa-comments-o'></i>
                </Link>
              }
            </div>
            <div className='c-cohorts'>
              <span className='cs-txt--sp-gray'>{player.cohorts}</span>
            </div>
            <div>
              <span className='cs-txt--sp-gray'>{player.formattedAge}</span><br />
              <span className='cs-txt--sp-gray'>{join(player.careGivers, ', ')}</span>
            </div>
          </div>
        </div>
        { webNotesCount > 0 && playerQuestionnaireId &&
          <div className='column u-flex align-right'>
            <span className='o-player-header__notes-number u-margin-right--small'><b>{webNotesCount}</b></span>
            <span className='o-player-header__notes cs-bg--light u-pointer' onClick={showSurveyNotesModal}>
              <i className='sp-icon-list'></i>
            </span>
          </div> }
      </div>
    </div>
  );
}

PlayerHeader.propTypes = {
  auth: PropTypes.object.isRequired,
  locationFrom: PropTypes.object,
  player: PropTypes.object,
  playerQuestionnaireId: PropTypes.number,
  webNotesCount: PropTypes.number.isRequired,
  search: PropTypes.string,
  showSurveyNotesModal: PropTypes.func.isRequired,
}

export default PlayerHeader;
